import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './common/font.css'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: 'XlPsgfgPfHqGz4qfQ433NjP7TpAsrbkX'
    //更换ak
	//ak: 'FpxZcB4bd3xoyzYgfBTqcwGiXNC8ASSU'
})

import axios from 'axios'
Vue.prototype.$axios = axios;

//vuex
import store from './store'
Vue.prototype.$store = store

Vue.config.productionTip = false

new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app')
